import { useQuery } from '@tanstack/react-query';

import getWorkDateOptions from 'Api/host-attendance-record/getWorkDateOptions';

import { useUserInfo } from 'Store/userInfo';
import getWorkDateOptionsResponse from 'Domain/host-attendance-record/model/response/getWorkDateOptionsResponse';

const useGetWorkDateOptions = () => {
  const { userId } = useUserInfo();

  return useQuery({
    queryKey: ['work-date-options', userId],
    queryFn: async () => {
      const response = await getWorkDateOptions();

      const result = getWorkDateOptionsResponse(response);

      return result;
    },
    refetchOnWindowFocus: false,
    retry: false,
    gcTime: 0,
  });
};

export default useGetWorkDateOptions;
